const PRIVACY_STATUS_PRIVATE = 1;
export default {
  data() {
    return {
      website: globalSite,
      page: currentPage,
    };
  },
  created() {
    this.fetchPages();
  },
  methods: {
    fetchPages() {
      this.menuPages = this.website.pages;

      if (this.website.privacy === PRIVACY_STATUS_PRIVATE) {
        this.menuPages = _.filter(this.website.pages, {access: this.page.access});
      }
    }
  }
}
